import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function androidBuildDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/android/build/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
